import { useTheme } from '@mui/material/styles';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const SquareMinus = (props: SvgIconProps) => {
  const theme = useTheme();
  return (
    <SvgIcon {...props}>
      <svg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <rect x='2' y='2' width='20' height='20' rx='6' fill='currentColor' />
        <path
          d='M8 12H16'
          stroke={
            theme.palette.mode === 'dark'
              ? theme.palette.common.black
              : theme.palette.common.white
          }
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </SvgIcon>
  );
};

export default SquareMinus;
